import { render } from "./EventGuestImage.vue?vue&type=template&id=77c807f6&scoped=true&ts=true"
import script from "./EventGuestImage.vue?vue&type=script&lang=ts"
export * from "./EventGuestImage.vue?vue&type=script&lang=ts"

import "./EventGuestImage.vue?vue&type=style&index=0&id=77c807f6&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c807f6"]])

export default __exports__